import React from "react";

const toggleFiltersIcon = (color = "") => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M20.7001 3.59995C20.6001 3.29995 20.3001 3.19995 20.0001 3.19995H4.00006C3.70006 3.19995 3.40006 3.39995 3.30006 3.59995C3.20006 3.89995 3.20006 4.19995 3.40006 4.39995L9.60006 13.6V19.7C9.60006 20.3 10.0001 20.7999 10.7001 20.7999H13.4001C14.0001 20.7999 14.5001 20.3 14.5001 19.7V13.6L20.7001 4.39995C20.8001 4.19995 20.9001 3.89995 20.7001 3.59995ZM13.0001 12.9C12.9001 13 12.8001 13.2 12.8001 13.3V19.1H11.2001V13.3C11.2001 13.1 11.1001 13 11.0001 12.9L9.10006 10.1C9.50006 9.99995 10.0001 9.89995 10.5001 9.89995C11.1001 9.89995 11.5001 9.99995 12.0001 10.1C12.5001 10.2 13.0001 10.3 13.6001 10.4C14.0001 10.4 14.4001 10.4 14.7001 10.3L13.0001 12.9ZM15.9001 8.59995C15.9001 8.59995 15.0001 8.99995 13.7001 8.99995C13.2001 8.99995 12.8001 8.89995 12.4001 8.79995C11.9001 8.69995 11.4001 8.49995 10.6001 8.49995C9.70006 8.49995 8.90006 8.69995 8.40006 8.89995L5.50006 4.79995H18.5001L15.9001 8.59995Z"
      fill={color}
    />
  </svg>
);

const searchIcon = (color = "#334455") => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5 13L1 17"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17 7C17 8.5913 16.3679 10.1174 15.2426 11.2426C14.1174 12.3679 12.5913 13 11 13C9.4087 13 7.88258 12.3679 6.75736 11.2426C5.63214 10.1174 5 8.5913 5 7C5 5.4087 5.63214 3.88258 6.75736 2.75736C7.88258 1.63214 9.4087 1 11 1C12.5913 1 14.1174 1.63214 15.2426 2.75736C16.3679 3.88258 17 5.4087 17 7V7Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const searchIconForInput = (color = "#d9d9d9") => (
  <svg width="15" height="15" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5 13L1 17"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17 7C17 8.5913 16.3679 10.1174 15.2426 11.2426C14.1174 12.3679 12.5913 13 11 13C9.4087 13 7.88258 12.3679 6.75736 11.2426C5.63214 10.1174 5 8.5913 5 7C5 5.4087 5.63214 3.88258 6.75736 2.75736C7.88258 1.63214 9.4087 1 11 1C12.5913 1 14.1174 1.63214 15.2426 2.75736C16.3679 3.88258 17 5.4087 17 7V7Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const toggleTableColumnsIcon = (color = "") => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 7.5H7.5V3H3V7.5ZM9.75 21H14.25V16.5H9.75V21ZM3 21H7.5V16.5H3V21ZM3 14.25H7.5V9.75H3V14.25ZM9.75 14.25H14.25V9.75H9.75V14.25ZM16.5 3V7.5H21V3H16.5ZM9.75 7.5H14.25V3H9.75V7.5ZM16.5 14.25H21V9.75H16.5V14.25ZM16.5 21H21V16.5H16.5V21Z"
      fill={color}
    />
  </svg>
);

const expandedTableEyeIcon = (color = "") => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0.75 8.99998C0.75 8.99998 3.75 2.99998 9 2.99998C14.25 2.99998 17.25 8.99998 17.25 8.99998C17.25 8.99998 14.25 15 9 15C3.75 15 0.75 8.99998 0.75 8.99998Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 11.25C10.2426 11.25 11.25 10.2426 11.25 9C11.25 7.75736 10.2426 6.75 9 6.75C7.75736 6.75 6.75 7.75736 6.75 9C6.75 10.2426 7.75736 11.25 9 11.25Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    <defs>
      <clipPath id="clip0">
        <rect width="18" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const paymentConfirmIcon = (color = "") => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9 0C6.59653 0 4.41322 0.942593 2.79925 2.47781L0.745717 0.424284C0.335496 0.0140629 0 0.15307 0 0.733253L0 5.37388C0 6.27026 0.146654 6.42857 1.05469 6.42857H5.69531C6.2755 6.42857 6.4145 6.09307 6.00428 5.68285L4.39072 4.06928C5.6455 2.89447 7.27313 2.25 9 2.25C10.8028 2.25 12.4979 2.95232 13.7728 4.22719C15.0477 5.50206 15.75 7.19719 15.75 9C15.75 10.8028 15.0477 12.4979 13.7728 13.7732C12.4979 15.0477 10.8028 15.75 9 15.75C7.19719 15.75 5.50206 15.0477 4.22719 13.7728C4.12072 13.6663 4.01866 13.5567 3.92022 13.4446L2.2271 14.9263C3.87682 16.8103 6.29919 18 9 18C13.9705 18 18 13.9705 18 9C18 4.0295 13.9705 0 9 0Z"
      fill={color}
    />
  </svg>
);

const adjustmentIcon = (color = "#0C77C6") => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.4095 5.86893L10.8864 5.34585C10.7326 5.19201 10.5172 5.19201 10.3633 5.34585L7.1018 8.57662L5.77873 7.28431C5.62488 7.13047 5.4095 7.13047 5.25565 7.28431L4.73257 7.80739C4.57873 7.96124 4.57873 8.17662 4.73257 8.33047L6.54796 10.1459C6.7018 10.2997 6.88642 10.3612 7.07103 10.3612C7.25565 10.3612 7.44026 10.2997 7.59411 10.1459L11.4095 6.39201C11.5326 6.26893 11.5326 6.02278 11.4095 5.86893ZM18.9172 9.37662H12.4864C12.2095 9.37662 11.9941 9.16124 11.9941 8.88432V7.8997C11.9941 7.62278 12.2095 7.40739 12.4864 7.40739H18.9172C19.1941 7.40739 19.4095 7.62278 19.4095 7.8997V8.88432C19.4095 9.16124 19.1941 9.37662 18.9172 9.37662ZM18.9172 13.7766H11.0095C10.7326 13.7766 10.5172 13.5612 10.5172 13.2843V12.2997C10.5172 12.0228 10.7326 11.8074 11.0095 11.8074H18.9172C19.1941 11.8074 19.4095 12.0228 19.4095 12.2997V13.2843C19.4095 13.5612 19.1941 13.7766 18.9172 13.7766ZM8.02488 13.7766H7.04026C6.76334 13.7766 6.54796 13.5612 6.54796 13.2843V12.2997C6.54796 12.0228 6.76334 11.8074 7.04026 11.8074H8.02488C8.3018 11.8074 8.51719 12.0228 8.51719 12.2997V13.2843C8.54796 13.5612 8.3018 13.7766 8.02488 13.7766ZM8.02488 18.1766H7.04026C6.76334 18.1766 6.54796 17.9612 6.54796 17.6843V16.6997C6.54796 16.4228 6.76334 16.2074 7.04026 16.2074H8.02488C8.3018 16.2074 8.51719 16.4228 8.51719 16.6997V17.6843C8.54796 17.9612 8.3018 18.1766 8.02488 18.1766ZM18.9172 18.1766H11.0095C10.7326 18.1766 10.5172 17.9612 10.5172 17.6843V16.6997C10.5172 16.4228 10.7326 16.2074 11.0095 16.2074H18.9172C19.1941 16.2074 19.4095 16.4228 19.4095 16.6997V17.6843C19.4095 17.9612 19.1941 18.1766 18.9172 18.1766Z"
      fill={color}
    />
    <mask id="mask0" masktype="alpha" maskUnits="userSpaceOnUse" x="4" y="5" width="16" height="14">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.4095 5.86893L10.8864 5.34585C10.7326 5.19201 10.5172 5.19201 10.3633 5.34585L7.1018 8.57662L5.77873 7.28431C5.62488 7.13047 5.4095 7.13047 5.25565 7.28431L4.73257 7.80739C4.57873 7.96124 4.57873 8.17662 4.73257 8.33047L6.54796 10.1459C6.7018 10.2997 6.88642 10.3612 7.07103 10.3612C7.25565 10.3612 7.44026 10.2997 7.59411 10.1459L11.4095 6.39201C11.5326 6.26893 11.5326 6.02278 11.4095 5.86893ZM18.9172 9.37662H12.4864C12.2095 9.37662 11.9941 9.16124 11.9941 8.88432V7.8997C11.9941 7.62278 12.2095 7.40739 12.4864 7.40739H18.9172C19.1941 7.40739 19.4095 7.62278 19.4095 7.8997V8.88432C19.4095 9.16124 19.1941 9.37662 18.9172 9.37662ZM18.9172 13.7766H11.0095C10.7326 13.7766 10.5172 13.5612 10.5172 13.2843V12.2997C10.5172 12.0228 10.7326 11.8074 11.0095 11.8074H18.9172C19.1941 11.8074 19.4095 12.0228 19.4095 12.2997V13.2843C19.4095 13.5612 19.1941 13.7766 18.9172 13.7766ZM8.02488 13.7766H7.04026C6.76334 13.7766 6.54796 13.5612 6.54796 13.2843V12.2997C6.54796 12.0228 6.76334 11.8074 7.04026 11.8074H8.02488C8.3018 11.8074 8.51719 12.0228 8.51719 12.2997V13.2843C8.54796 13.5612 8.3018 13.7766 8.02488 13.7766ZM8.02488 18.1766H7.04026C6.76334 18.1766 6.54796 17.9612 6.54796 17.6843V16.6997C6.54796 16.4228 6.76334 16.2074 7.04026 16.2074H8.02488C8.3018 16.2074 8.51719 16.4228 8.51719 16.6997V17.6843C8.54796 17.9612 8.3018 18.1766 8.02488 18.1766ZM18.9172 18.1766H11.0095C10.7326 18.1766 10.5172 17.9612 10.5172 17.6843V16.6997C10.5172 16.4228 10.7326 16.2074 11.0095 16.2074H18.9172C19.1941 16.2074 19.4095 16.4228 19.4095 16.6997V17.6843C19.4095 17.9612 19.1941 18.1766 18.9172 18.1766Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0)" />
  </svg>
);

const chargeIcon = (color = "#45B058") => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.2729 8.96923H10.5633C10.2313 8.96923 9.97312 8.75385 9.97312 8.47692V7.49231C9.97312 7.21538 10.2313 7 10.5633 7H18.2729C18.6049 7 18.8631 7.21538 18.8631 7.49231V8.47692C18.8631 8.75385 18.6049 8.96923 18.2729 8.96923ZM18.3692 13.3692H10.4615C10.1846 13.3692 9.96923 13.1538 9.96923 12.8769V11.8923C9.96923 11.6154 10.1846 11.4 10.4615 11.4H18.3692C18.6462 11.4 18.8615 11.6154 18.8615 11.8923V12.8769C18.8615 13.1538 18.6462 13.3692 18.3692 13.3692ZM7.47692 13.3696H6.49231C6.21538 13.3696 6 13.1542 6 12.8773V11.8927C6 11.6158 6.21538 11.4004 6.49231 11.4004H7.47692C7.75385 11.4004 7.96923 11.6158 7.96923 11.8927V12.8773C8 13.1542 7.75385 13.3696 7.47692 13.3696ZM7.47692 8.97103H6.49231C6.21538 8.97103 6 8.75564 6 8.47872V7.4941C6 7.21718 6.21538 7.0018 6.49231 7.0018H7.47692C7.75385 7.0018 7.96923 7.21718 7.96923 7.4941V8.47872C8 8.75564 7.75385 8.97103 7.47692 8.97103ZM7.47692 17.7692H6.49231C6.21538 17.7692 6 17.5538 6 17.2769V16.2923C6 16.0154 6.21538 15.8 6.49231 15.8H7.47692C7.75385 15.8 7.96923 16.0154 7.96923 16.2923V17.2769C8 17.5538 7.75385 17.7692 7.47692 17.7692ZM18.3692 17.7692H10.4615C10.1846 17.7692 9.96923 17.5538 9.96923 17.2769V16.2923C9.96923 16.0154 10.1846 15.8 10.4615 15.8H18.3692C18.6462 15.8 18.8615 16.0154 18.8615 16.2923V17.2769C18.8615 17.5538 18.6462 17.7692 18.3692 17.7692Z"
      fill={color}
    />
    <mask id="mask0" masktype="alpha" maskUnits="userSpaceOnUse" x="6" y="11" width="13" height="7">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.3692 13.3696H10.4615C10.1846 13.3696 9.96923 13.1542 9.96923 12.8773V11.8927C9.96923 11.6158 10.1846 11.4004 10.4615 11.4004H18.3692C18.6462 11.4004 18.8615 11.6158 18.8615 11.8927V12.8773C18.8615 13.1542 18.6462 13.3696 18.3692 13.3696ZM7.47692 17.7696H6.49231C6.21538 17.7696 6 17.5542 6 17.2773V16.2927C6 16.0158 6.21538 15.8004 6.49231 15.8004H7.47692C7.75385 15.8004 7.96923 16.0158 7.96923 16.2927V17.2773C8 17.5542 7.75385 17.7696 7.47692 17.7696ZM18.3692 17.7696H10.4615C10.1846 17.7696 9.96923 17.5542 9.96923 17.2773V16.2927C9.96923 16.0158 10.1846 15.8004 10.4615 15.8004H18.3692C18.6462 15.8004 18.8615 16.0158 18.8615 16.2927V17.2773C18.8615 17.5542 18.6462 17.7696 18.3692 17.7696Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0)" />
  </svg>
);

const repeatIcon = (color = "#DADADA") => (
  <svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.55 4.55L7 0V3.07C3.06 3.56 0 6.92 0 11C0 15.08 3.05 18.44 7 18.93V16.91C4.16 16.43 2 13.97 2 11C2 8.03 4.16 5.57 7 5.09V9L11.55 4.55ZM15.93 10C15.7519 8.58065 15.192 7.23623 14.31 6.11L12.89 7.53C13.43 8.28 13.77 9.13 13.91 10H15.93ZM9 16.9V18.92C10.39 18.75 11.74 18.21 12.9 17.31L11.46 15.87C10.71 16.41 9.87 16.76 9 16.9ZM12.89 14.48L14.31 15.89C15.21 14.73 15.76 13.39 15.93 12H13.91C13.77 12.87 13.43 13.72 12.89 14.48Z"
      fill={color}
    />
  </svg>
);

const crossIcon = (color = "") => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2 2L14 13.9395" stroke={color} strokeWidth="2" strokeLinecap="round" />
    <path
      d="M14.0012 2.00195L2.03125 14.002"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

const inputClearIcon = (style = {}) => (
  <span className="ant-input-suffix" style={style}>
    <span
      role="button"
      aria-label="close-circle"
      tabIndex="-1"
      className="anticon anticon-close-circle ant-input-clear-icon"
    >
      <svg
        viewBox="64 64 896 896"
        focusable="false"
        data-icon="close-circle"
        width="1em"
        height="1em"
        fill="currentColor"
        aria-hidden="true"
      >
        <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm165.4 618.2l-66-.3L512 563.4l-99.3 118.4-66.1.3c-4.4 0-8-3.5-8-8 0-1.9.7-3.7 1.9-5.2l130.1-155L340.5 359a8.32 8.32 0 01-1.9-5.2c0-4.4 3.6-8 8-8l66.1.3L512 464.6l99.3-118.4 66-.3c4.4 0 8 3.5 8 8 0 1.9-.7 3.7-1.9 5.2L553.5 514l130 155c1.2 1.5 1.9 3.3 1.9 5.2 0 4.4-3.6 8-8 8z" />
      </svg>
    </span>
  </span>
);

export {
  toggleFiltersIcon,
  searchIcon,
  toggleTableColumnsIcon,
  paymentConfirmIcon,
  chargeIcon,
  adjustmentIcon,
  crossIcon,
  expandedTableEyeIcon,
  repeatIcon,
  inputClearIcon,
  searchIconForInput,
};
